import { render, staticRenderFns } from "./w-logo-native.global.vue?vue&type=template&id=869ed8f6&scoped=true"
import script from "./w-logo-native.global.vue?vue&type=script&lang=js"
export * from "./w-logo-native.global.vue?vue&type=script&lang=js"
import style0 from "./w-logo-native.global.vue?vue&type=style&index=0&id=869ed8f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869ed8f6",
  null
  
)

export default component.exports